import React from 'react';

import Users from 'features/admin/ui/User/Users';
import AddPaymentButton from 'features/admin/ui/AddPaymentButton/AddPaymentButton';

import useShowAddPaymentButton from '../../model/useShowAddPaymentButton';

const AdminUsersScreen: React.FC = () => {
    const showAddPayment = useShowAddPaymentButton();

    return (
        <>
            <Users />
            {showAddPayment && <AddPaymentButton />}
        </>
    );
};

export default AdminUsersScreen;
